import React, { useEffect, useState } from "react";
import { Trophy, Sparkles } from "lucide-react";
import api from "../lib/api";
import { NeonCard, Spinner, SectionTitle } from "../components/Neon";
import { gbp } from "../lib/format";
import { useDocumentSeo } from "../lib/seo";

export default function Winners() {
  const [winners, setWinners] = useState([]);
  const [loading, setLoading] = useState(true);
  useDocumentSeo({ title: "Winners | Richi\u00a3 Rich Competitions", description: "See the real winners of our UK luxury prize competitions \u2014 cars, watches and tax-free cash." });

  useEffect(() => {
    api.get("/winners").then(({ data }) => setWinners(Array.isArray(data) ? data : data.winners || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-12" data-testid="winners-page">
      <div className="flex items-center gap-2"><Trophy className="h-6 w-6 text-[var(--neon-gold)]" /><SectionTitle accent="gold">Our Winners</SectionTitle></div>
      <p className="mt-1 text-sm text-[var(--text-muted)]">Every draw is run live with a verifiable random draw. Here are our lucky winners.</p>

      {loading ? <Spinner className="mt-10" /> : winners.length === 0 ? (
        <NeonCard variant="soft" className="mt-8" innerClassName="p-10 text-center">
          <Sparkles className="mx-auto h-8 w-8 text-[var(--neon-gold)]" />
          <p className="mt-3 font-display uppercase text-white">Winners revealed after launch</p>
          <p className="mt-1 text-sm text-[var(--text-muted)]">Our first live draws happen on launch night \u2014 check back to see who wins big.</p>
        </NeonCard>
      ) : (
        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="winners-list">
          {winners.map((w, i) => (
            <NeonCard key={w.id || i} variant="flow" innerClassName="p-5">
              <div className="flex items-center gap-3">
                {w.hero_image ? <img src={w.hero_image} alt="" className="h-14 w-14 rounded-lg object-cover border border-white/10" /> : <div className="h-14 w-14 rounded-lg bg-[var(--surface-2)] flex items-center justify-center"><Trophy className="h-6 w-6 text-[var(--neon-gold)]" /></div>}
                <div className="min-w-0">
                  <p className="font-display text-white truncate">{w.winner_name || w.name || "Lucky Winner"}</p>
                  <p className="text-xs text-[var(--text-muted)] truncate">{w.competition_title || w.title || ""}</p>
                </div>
              </div>
              <div className="mt-3 flex items-center justify-between">
                <span className="text-sm text-[var(--neon-gold)] font-display">{w.prize_title || w.prize || ""}</span>
                {(w.prize_value || w.value) ? <span className="text-[var(--neon-green)] text-sm">{gbp(w.prize_value || w.value)}</span> : null}
              </div>
              {(w.drawn_at || w.created_at) && <p className="mt-1 text-[11px] text-[var(--text-muted)]">{new Date(w.drawn_at || w.created_at).toLocaleDateString("en-GB")}</p>}
            </NeonCard>
          ))}
        </div>
      )}
    </div>
  );
}
